export enum SCREEN_ORIENTATION {
    PORTRAIT,
    LANDSCAPE
}
